import { useQuery, useQueryClient } from '@tanstack/react-query'
import { userKeys } from './keys'
import { getUserPermissions } from 'api/userPermissions'
import { QueryOptions } from 'queries/types'

export function useUserPermissions(
  userId?: string,
  options: QueryOptions<typeof getUserPermissions> = {}
) {
  return useQuery({
    ...options,
    queryKey: userKeys.permissions.byUserId(userId),
    queryFn: getUserPermissions,
    enabled: !!userId,
  })
}

export function useInvalidateUserPermissions() {
  const queryClient = useQueryClient()

  return {
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: userKeys.permissions.all,
      }),
  }
}
